// extracted by mini-css-extract-plugin
module.exports = {"base":"SkipLink_base__4IkXt","dark":"SkipLink_dark__dJzfK SkipLink_base__4IkXt","light":"SkipLink_light__8x35x SkipLink_base__4IkXt","fadeOut":"SkipLink_fadeOut__8m3__"};